export default __webpack_public_path__ + "static/media/Amazon-Logo-PNG.98d38b43.png";